import { EditorToolbar, EditorV2 } from "@inputs/text/EditorV2";
import { Box, FormControlLabel, Switch, Typography } from "@mui/material";
import { useGlobalContext } from "@root/context";
import { useEffect, useState } from "react";
import { type Control, Controller, type UseFormSetValue, useWatch } from "react-hook-form";
import type { IModalActionForm, IModalActionResolver } from "../logics/types";

interface IBeneficiaryCommentProps {
  control: Control<IModalActionForm, void, IModalActionResolver>;
  hidden?: boolean;
  setValue: UseFormSetValue<IModalActionForm>;
}

export const BeneficiaryComment = ({ control, hidden = false, setValue }: IBeneficiaryCommentProps) => {
  const beneficiaryCommentValue = useWatch({
    control,
    name: "beneficiaryComment",
  });
  const [beneficiaryComment, setBeneficiaryComment] = useState(!!beneficiaryCommentValue);
  const { user } = useGlobalContext();
  const selectedActionType = useWatch({ control, name: "type.value" });

  useEffect(() => {
    if (!beneficiaryComment) {
      setValue("beneficiaryComment", null);
    }
  }, [beneficiaryComment, setValue]);

  if (
    hidden ||
    !user.organisation.beneficiaryConfiguration?.meetingActionTypes.some((mAT) => mAT === selectedActionType)
  ) {
    return null;
  }

  return (
    <>
      <FormControlLabel
        sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}
        control={
          <Switch
            sx={{ marginRight: -1, pointerEvents: "auto" }}
            onChange={(_, checked) => setBeneficiaryComment(checked)}
            checked={beneficiaryComment}
            color="primary"
          />
        }
        label={<Typography>Ajouter un encart de texte à destination du candidat</Typography>}
        labelPlacement="start"
      />
      {beneficiaryComment && (
        <Controller
          control={control}
          name="beneficiaryComment"
          render={({ field: { value, onChange, onBlur } }) => (
            <Box
              sx={{
                height: 210,
              }}
            >
              <EditorV2
                value={value ?? ""}
                onChange={onChange}
                onBlur={onBlur}
                init={{
                  toolbar: [EditorToolbar.EDITORV2],
                  // biome-ignore lint/style/useNamingConvention: <explanation>
                  max_height: 210,
                  placeholder:
                    'Notez un message à destination de votre candidat, qu\'il visualisera depuis son compte dans la page "Mes rendez-vous" (documents à ne pas oublier, résumé de ce que vous vous êtes dit en rdv...)',
                }}
              />
            </Box>
          )}
        />
      )}
    </>
  );
};
